import React from 'react'
import propTypes from "prop-types";
import { NavBar } from 'antd-mobile'
import { useNavigate } from 'react-router-dom';
import {  BG_LAYOUT_COLOR } from '../../constants/color';
import "./../../styles.css"

export default function HeaderMobile(props) {
  const navigate = useNavigate();

    return (
      <NavBar
        className={props.className ? props.className : ''}
        style={{ 
          background: BG_LAYOUT_COLOR,
          fontWeight: "bold" }}
        back={props.back}
        right={props.right}
        onBack={() => props.onClick ? props.onClick() : navigate(-1)}>
          {props.title}
      </NavBar>
    )
  }
  
  HeaderMobile.defaultProps = {
    title: null,
    back: null, //ปุ่มกลับ
    onClick: null,
    right : null,
  }
  
  HeaderMobile.propTypes = {
    title: propTypes.string,
    back: propTypes.bool,
    onClick: propTypes.func,
  }
  